import {type IRootState} from "../../store/store";

export const selectSemanticSearchHasConversation = (state: IRootState): boolean => state.semanticSearchModal.hasConversation;
import {type IRootState} from "../../store/store";

export const selectSemanticSearchHasConversation = (state: IRootState): boolean => state.semanticSearchModal.hasConversation;
